import {isSymbolRoot} from '@packages/systems/core/utils/DomTypeUtils';
import type {Context} from '../types';
import {
  emptyEnhancedExtraContext,
  type EnhancedExtraContext,
} from '../ExtraContext';

/**
 * This patch requires extraContext.validPageIds to run. If provided
 * it will patch symbol roots that are tracking copies of itself on deleted pages
 */

function getDeletedPagesBeingTracked(
  jsonNode: Record<any, any>,
  extraContext: EnhancedExtraContext = emptyEnhancedExtraContext
) {
  const {validPageIds} = extraContext;
  const {data = {}} = jsonNode;
  const deletedPagesBeingTracked: Array<any | string> = [];

  // There should always be at least one page, so if validPageIds is not provided
  // or is an empty array we should skip this patch.
  if (
    validPageIds &&
    validPageIds.length &&
    isSymbolRoot(data) &&
    data.sym.copies
  ) {
    for (const pageId in data.sym.copies) {
      if (!validPageIds.includes(pageId)) {
        deletedPagesBeingTracked.push(pageId);
      }
    }
  }

  return deletedPagesBeingTracked;
}

export default (context: Context) => {
  const {
    node: {jsonNode},
    extraContext,
  } = context;
  const pagesToStopTracking = getDeletedPagesBeingTracked(
    jsonNode,
    extraContext
  );

  return {
    needed: Boolean(pagesToStopTracking.length),
    logData: {
      msg: 'Symbol tracking usage on deleted pages',
      meta: {
        nodeId: jsonNode._id,
        pagesToStopTracking,
      },
    },
    apply: () => {
      const copies = jsonNode.data && jsonNode.data.sym.copies;

      pagesToStopTracking.forEach((deletedPageId) => {
        // eslint-disable-next-line webflow/no-delete
        delete copies[deletedPageId];
      });

      if (!Object.keys(copies).length) {
        if (jsonNode.data && jsonNode.data.sym) {
          // eslint-disable-next-line webflow/no-delete
          delete jsonNode.data.sym.copies;
        }
      }
    },
  };
};
